import React, { useState } from "react";
import { ApiHook } from "../../hooks/apiHook";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import "./Webinar.css";

const Webinar = () => {
  const { t } = useTranslation();
  const webinarLinks = ApiHook.CallGetWebinarLinks();
  const [copiedId, setCopiedId] = useState(null);

  const openWebinar = (link) => {
    if (link) {
      window.open(link, '_blank', 'noopener,noreferrer');
    }
  };

  const copyToClipboard = async (text, id) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopiedId(id);
      toast.success(t("link_copied") || "Link copied to clipboard!");
      
      // Reset the copied state after 2 seconds
      setTimeout(() => {
        setCopiedId(null);
      }, 2000);
    } catch (err) {
      // Fallback for older browsers
      const textArea = document.createElement('textarea');
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      
      setCopiedId(id);
      toast.success(t("link_copied") || "Link copied to clipboard!");
      
      setTimeout(() => {
        setCopiedId(null);
      }, 2000);
    }
  };

  return (
    <>
      <div className="page_head_top">{t("webinar") || "Webinar"}</div>
      <div className="container-fluid mt-4">
        {webinarLinks?.data?.length > 0 ? (
          <div className="table-responsive">
            <table className="table table-hover table-striped">
              <thead className="table-dark">
                <tr>
                  <th scope="col" >#</th>
                  <th scope="col" >{t("title") || "Title"}</th>
                  <th scope="col" >{t("webinar_link") || "Webinar Link"}</th>
                </tr>
              </thead>
              <tbody>
                {webinarLinks.data.map((webinar, index) => (
                  <tr key={webinar.id || index}>
                    <td className="fw-bold text-primary">{index + 1}</td>
                    <td>
                      <div className="d-flex align-items-center">
                        <i className="fas fa-video text-primary me-2"></i>
                        <div>
                          <div className="fw-semibold">
                            {webinar.title || webinar.link || 'Webinar Session'}
                          </div>
                          {webinar.description && (
                            <small className="text-muted">
                              {webinar.description.length > 100 
                                ? webinar.description.substring(0, 100) + '...'
                                : webinar.description
                              }
                            </small>
                          )}
                        </div>
                      </div>
                    </td>
                    <td>
                      {webinar.link ? (
                        <div className="d-flex gap-2">
                          <button 
                            className="btn btn-sm JoinWebinarButton" 
                            onClick={() => openWebinar(webinar.link)}
                            title={t("join_webinar") || "Join Webinar"}
                            style={{color:"white !important"}}
                          >
                            <i className="fas fa-external-link-alt me-1"></i>
                            {t("join") || "Join"}
                          </button>
                          <button 
                            className={`btn btn-outline-secondary btn-sm ${copiedId === (webinar.id || index) ? 'btn-success' : ''}`}
                            onClick={() => copyToClipboard(webinar.link, webinar.id || index)}
                            title={t("copy_link") || "Copy Link"}
                          >
                            <i className={`fas ${copiedId === (webinar.id || index) ? 'fa-check' : 'fa-copy'} me-1`}></i>
                            {copiedId === (webinar.id || index) 
                              ? (t("copied") || "Copied") 
                              : (t("copy") || "Copy")
                            }
                          </button>
                        </div>
                      ) : (
                        <span className="text-muted">{t("no_link_available") || "No link available"}</span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="text-center py-5" style={{backgroundColor: 'white',marginTop: '50px'}}>
            <img 
              src="images/no-data-image1.jpg" 
              alt="No webinars" 
              className="img-fluid mb-3"
              style={{ maxWidth: '300px', opacity: '0.7' }}
            />
            <h5 className="text-muted">{t("sorry_no_data_found")}</h5>
            <p className="text-muted">{t("no_webinars_available") || "No webinar links are currently available."}</p>
          </div>
        )}
      </div>
    </>
  );
};

export default Webinar;
